// import React from 'react';
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { AuthProvider } from './context/AuthContext';
import { HelmetProvider } from 'react-helmet-async';

// Layout Components
//import Layout from './components/Layout';

// Pages
import Home from './pages/Home';
import ProductDetail from './pages/ProductDetail';
import Dashboard from './pages/Dashboard';
import Cart from './components/Cart';
import Login from './pages/Login';
import Register from './pages/Register';
// import InvoiceTestPage from './pages/InvoiceTestPage';


function App() {

  return (
    <HelmetProvider>
      <AuthProvider>
        <CartProvider>
          <Router>

            
            <Cart/>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/login" element={<Login />} />
              <Route path="/dashboard/*" element={<Dashboard />} />
              {/* Dans votre App.js */}
              <Route path="/product/:id" element={<ProductDetail />} />
              // Dans votre App.js
              <Route path="/register" element={<Register />} /> 
              <Route path="/login" element={<Login />} />
              {/* <Route path="/invoice-test" element={<InvoiceTestPage />} /> */}
              {/* <Route path="/checkout" element={<Checkout />} /> */}
            </Routes>
          </Router>
        </CartProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;